import { render, staticRenderFns } from "./Rent.vue?vue&type=template&id=28b819aa&scoped=true&"
import script from "./Rent.vue?vue&type=script&lang=js&"
export * from "./Rent.vue?vue&type=script&lang=js&"
import style0 from "./Rent.vue?vue&type=style&index=0&id=28b819aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b819aa",
  null
  
)

export default component.exports